<ng-container *ngIf="{ selected: selectedItem$ | async, isMobile: isMobile$ | async } as vm">
  <!-- Desktop -->
  <div
    ngbDropdown
    #dropdown="ngbDropdown"
    container="body"
    [dropdownClass]="menuClass"
    [popperOptions]="fixToAnchorWidth ? popperOptionsFixed : popperOptions"
    [hidden]="vm.isMobile"
    (openChange)="onDropdownOpenChange($event)">
    <button
      type="button"
      ngbDropdownToggle
      #dropdownToggle
      class="dropdown-input"
      [attr.id]="controlId"
      [attr.name]="name"
      [class.form-error-border]="error"
      [attr.aria-invalid]="error ? true : null"
      [class.disabled]="disabled"
      [class.dropdown-open]="dropdown.isOpen()"
      [class.placeholder-selected]="!!vm.selected"
      [class.has-inline-clear]="!!inlineClearText && !disabled && !!vm.selected"
      [disabled]="disabled">
      {{ vm.selected?.getSelectionTitle() || placeholder }}
    </button>
    <button
      *ngIf="inlineClearText && !disabled && vm.selected"
      type="button"
      class="inline-clear"
      (click)="clearSelection($event)">
      {{ inlineClearText }}
    </button>
    <div
      ngbDropdownMenu
      #dropdownMenu
      class="dropdown-content"
      [class.dropdown-content--fixed-width]="fixToAnchorWidth">
      <button
        type="button"
        ngbDropdownItem
        class="dropdown-item clearable"
        *ngIf="clearable && !disabled && vm.selected"
        (click)="resetInput()"
        i18n>
        Clear Selection
      </button>
      <ng-container *ngFor="let group of groups; trackBy: trackByGroupLabel">
        <div class="dropdown-header" *ngIf="group.label">{{ group.label }}</div>
        <button
          type="button"
          ngbDropdownItem
          class="dropdown-item"
          *ngFor="let item of group.items; trackBy: trackByValue"
          (click)="itemSelected(item)"
          [class.disabled]="item.getSelectionIsDisabled()"
          [class.selected]="item.getSelectionValue() === vm.selected?.getSelectionValue()"
          [disabled]="item.getSelectionIsDisabled()">
          <ng-container [ngSwitch]="item.getSelectionValue() === vm.selected?.getSelectionValue()">
            <img *ngSwitchCase="true" class="icon-img" src="assets/icons/dark/Check.svg" alt="" aria-hidden="true" />
            <ng-container *ngSwitchDefault>
              <img *ngIf="item?.iconSrc" class="icon-img" [src]="item.iconSrc" alt="" aria-hidden="true" />
              <div *ngIf="!item?.iconSrc" class="icon-img"></div>
            </ng-container>
          </ng-container>
          {{ item.getSelectionTitle() }}
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Mobile -->
  <select
    *ngIf="vm.isMobile"
    class="dropdown-input"
    [disabled]="disabled"
    [class.form-error-border]="error"
    [attr.aria-invalid]="error ? true : null"
    [value]="vm.selected?.getSelectionValue() ?? ''"
    [ngClass]="{ 'placeholder-selected': !vm.selected?.getSelectionValue() }"
    (focus)="inputFocused.emit()"
    (change)="onSelectChanged($event)">
    <option value="" disabled>
      {{ placeholder }}
    </option>
    <ng-container *ngFor="let group of groups; trackBy: trackByGroupLabel">
      <optgroup *ngIf="group.label" [label]="group.label">
        <option
          *ngFor="let drop of group.items; trackBy: trackByValue"
          [value]="drop.getSelectionValue()"
          [disabled]="drop.getSelectionIsDisabled()">
          {{ drop.getSelectionTitle() }}
        </option>
      </optgroup>
      <ng-container *ngIf="!group.label">
        <option
          *ngFor="let drop of group.items; trackBy: trackByValue"
          [value]="drop.getSelectionValue()"
          [disabled]="drop.getSelectionIsDisabled()">
          {{ drop.getSelectionTitle() }}
        </option>
      </ng-container>
    </ng-container>
  </select>
</ng-container>
